import { Box } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import FormsTable from "./FormsTable"
import { useEffect } from "react"
import { createFormAction, deleteFormAction, initializeConfigForms, updateFormAction } from "redux/reducers/configFormsReducer"
import { initializeStudy } from "redux/reducers/studyReducer"

const DisplayForms = () => {
  const centerId = useSelector(({ center }) => center)?.data?.id
  const formsConfig = useSelector(({ formsConfig }) => formsConfig)
  const selectedCenterStudyId = useSelector(({ center }) => center)?.data?.studyId
  const { data: studyData } = useSelector(({ study }) => study)

  const dispatch = useDispatch()

  useEffect(() => {
    if (centerId && formsConfig.data?.length === 0) {
      dispatch(initializeConfigForms(centerId))
    }
  }, [centerId, dispatch])


  useEffect(() => {
    if (selectedCenterStudyId && !studyData) {
      dispatch(initializeStudy(selectedCenterStudyId))
    }
  }, [selectedCenterStudyId, studyData, dispatch])

  const actions = {
    create: createFormAction,
    update: updateFormAction,
    remove: deleteFormAction
  }

  if (!formsConfig) return null;

  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {centerId && <FormsTable entityId={centerId} formsConfig={formsConfig} actions={actions} canCreate={true}/>}
    </Box>
  )
}

export default DisplayForms